/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or continue with`)
};

const zh_hans1_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或继续使用`)
};

const zh_hant1_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或繼續使用`)
};

const fr_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou continuer avec`)
};

const de_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder fortfahren mit`)
};

const ja_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`または次で続行`)
};

const ko_login_or_continue = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`또는 다음으로 계속`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_or_continue = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_or_continue(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_or_continue", locale)
	if (locale === "en") return en_login_or_continue(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_or_continue(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_or_continue(inputs)
	if (locale === "fr") return fr_login_or_continue(inputs)
	if (locale === "de") return de_login_or_continue(inputs)
	if (locale === "ja") return ja_login_or_continue(inputs)
	return ko_login_or_continue(inputs)
};